import type { UserProfile } from "../../domain/entities/user-profile";

export abstract class UserRepository {
  abstract getUserProfile(): Promise<UserProfile>;
}
